// ...existing code...
import React, { useEffect, useState } from "react";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import { FaFileDownload } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDateTime } from "../../utils/date";
const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const CURRENCY_SYMBOLS = { usd: "$", inr: "₹", eur: "€", gbp: "£" };
// ...existing code...

export default function OrderReceipt() {
  const location = useLocation();
  const navigate = useNavigate();

  // prefer navigate state; fallback to sessionStorage (saved by ShopperAdders)
  const [checkout, setCheckout] = useState(() => {
    const stateCheckout =
      location.state?.orderData || location.state?.checkoutResponse || location.state?.checkout || location.state?.result;
    if (stateCheckout) return stateCheckout;
    try {
      const stored = sessionStorage.getItem("checkoutResponse");
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const [shipping, setShipping] = useState(() => {
    const stateShipping = location.state?.shippingAddress;
    if (stateShipping) return stateShipping;
    try {
      const stored = sessionStorage.getItem("shippingAddress");
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    // update from navigation state when arriving via navigate(...)
    const stateCheckout =
      location.state?.orderData || location.state?.checkoutResponse || location.state?.checkout || location.state?.result;
    if (stateCheckout) {
      setCheckout(stateCheckout);
    }
    if (location.state?.shippingAddress) {
      setShipping(location.state.shippingAddress);
    }
  }, [location.state]);


  // --- NEW: fetch product images for items that don't have an image ---
  const [images, setImages] = useState({}); // map productId -> imageUrl

  useEffect(() => {
    if (!checkout?.orders?.length) return;

    const idsToFetch = new Set();

    checkout.orders.forEach((order) => {
      (order.order_items || []).forEach((it) => {
        // if item already has image or we already fetched it, skip
        if (it.image || images[it.product_id]) return;
        idsToFetch.add(it.product_id);
      });
    });

    if (idsToFetch.size === 0) return;

    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken") || "";

    // fetch each product detail and extract first media url
    const fetchForId = async (productId) => {
      try {
        const url = `${API_BASE_URL}/product?id=${encodeURIComponent(productId)}`;
        const res = await fetch(url, {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { token } : {}),
          },
        });
        if (!res.ok) return null;
        const json = await res.json();
        const result = json?.result;
        const img = result?.product_media?.[0]?.url || result?.image || null;
        return img;
      } catch (e) {
        return null;
      }
    };

    let mounted = true;
    (async () => {
      const updates = {};
      for (const id of idsToFetch) {
        // avoid refetching if another effect already set it
        if (images[id]) continue;
        const img = await fetchForId(id);
        if (img && mounted) updates[id] = img;
      }
      if (mounted && Object.keys(updates).length) {
        setImages((prev) => ({ ...prev, ...updates }));
      }
    })();

    return () => {
      mounted = false;
    };
  }, [checkout, images]);

  // derive useful values
  const orders = checkout?.orders || [];
  const currencySymbol = CURRENCY_SYMBOLS[orders[0]?.seller?.currency?.toLowerCase()] || "$";
  const totalAmount =
    checkout?.total_amount ??
    orders.reduce((s, o) => s + (o.pricing?.final_amount ?? 0), 0);
  const paymentIntent = location.state?.paymentIntent || null;
  const walletPaid = Number(checkout?.wallet_applied) || 0;
  const paidByWallet = checkout?.paid === true;
  const paymentConfirmed = paidByWallet || paymentIntent?.status === "succeeded";
  const orderNumbers = orders
    .map((o) => o.order_number || (o.order_id ? `#${o.order_id}` : null))
    .filter(Boolean);
  const orderDate =
    orders[0]?.created_at ||
    (paymentIntent?.created ? new Date(paymentIntent.created * 1000) : null);
  const paymentRef = (paidByWallet && checkout.wallet_reference) || paymentIntent?.id || checkout?.payment_intent_id || "N/A";
  const paymentMethodLabel = paidByWallet
    ? "Wallet"
    : paymentIntent
      ? walletPaid > 0 ? "Wallet + Card" : "Card"
      : checkout?.payment_method
        ? checkout.payment_method.charAt(0).toUpperCase() + checkout.payment_method.slice(1)
        : "N/A";

  if (!checkout) {
    return (
      <div className="dashboard w-full min-h-screen flex">
        <Leftsidebar />
        <main className="flex-1 min-w-0  p-6">
          <LeftResponsivesidebar />
          <Headmenu />
          <div className="mx-auto p-6 bg-white rounded-xl shadow-lg text-center">
            <h2 className="text-lg font-semibold mb-4">No order data available</h2>
            <p className="text-sm text-gray-600 mb-4">
              No checkout response found. You can go back to orders or home.
            </p>
            <div className="flex justify-center gap-3">
              <button onClick={() => navigate(-1)} className="px-4 py-2 border rounded whitespace-nowrap">
                ← Back
              </button>
              <button onClick={() => navigate("/marketplace")} className="px-4 py-2 bg-green-700 text-white rounded whitespace-nowrap">
                Continue Shopping
              </button>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="dashboard w-full min-h-screen flex">
      <Leftsidebar />

      <main className="flex-1 min-w-0  p-6">
        <LeftResponsivesidebar />
        <Headmenu />
        <div className=" mx-auto p-6 bg-white rounded-xl shadow-lg">
          <div className="flex flex-col items-center mb-6">
            <div className=" rounded-full p-4 mb-3">
              {paymentConfirmed && (
                <img
                  src="/image/success.png"
                  className="w-[100px] h-[100px]"
                  alt=""
                />
              )}
            </div>
            <h2 className="text-lg font-semibold mb-1">
              {paymentConfirmed ? "Thank you! Your order has been placed." : "Order Details"}
            </h2>
            <p className="text-gray-500 mb-4 text-center">
              {paymentConfirmed
                ? "Your payment was successful."
                : "Check My Orders for the latest payment and delivery status of this order."}
            </p>
            <div className="text-center mb-2">
              <div className="text-gray-500 text-xs">{paymentConfirmed ? "Total Payment" : "Order Total"}</div>
              <div className="text-2xl font-bold">{currencySymbol}{Number(totalAmount || 0).toFixed(2)}</div>
              {orderDate && (
                <div className="text-xs text-gray-400">{formatDateTime(orderDate)}</div>
              )}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 mb-6">
            <div className="border p-2 space-y-1 rounded-md">
              <div className="text-xs text-gray-500">{orderNumbers.length > 1 ? "Order Nos" : "Order No"}</div>
              <div className="font-medium break-all">
                {orderNumbers.length ? orderNumbers.join(", ") : "N/A"}
              </div>
            </div>
            <div className="border p-2 space-y-1 rounded-md">
              <div className="text-xs text-gray-500">Payment Ref No.</div>
              <div className="font-medium break-all">{paymentRef}</div>
            </div>
            <div className="border p-2 space-y-1 rounded-md">
              <div className="text-xs text-gray-500">Name</div>
              <div className="font-medium">{shipping?.name || "N/A"}</div>
            </div>
            <div className="border p-2 space-y-1 rounded-md">
              <div className="text-xs text-gray-500">Payment Method</div>
              <div className="font-medium">{paymentMethodLabel}</div>
            </div>
            {walletPaid > 0 && (
              <>
                <div className="border p-2 space-y-1 rounded-md">
                  <div className="text-xs text-gray-500">Paid with Wallet Coins</div>
                  <div className="font-medium">
                    {currencySymbol}{walletPaid.toFixed(2)}
                    {currencySymbol !== "$" && checkout.wallet_coins > 0 && (
                      <span className="text-gray-500"> (${Number(checkout.wallet_coins).toFixed(2)} coins)</span>
                    )}
                  </div>
                </div>
                <div className="border p-2 space-y-1 rounded-md">
                  <div className="text-xs text-gray-500">Wallet Balance</div>
                  <div className="font-medium">${Number(checkout.wallet_balance || 0).toFixed(2)}</div>
                </div>
              </>
            )}
          </div>

          <div className="mb-4 border p-2 space-y-1 rounded-md">
            <div className="text-xs text-gray-500 mb-1">Shipping Details</div>
            {shipping ? (
              <div className="font-medium">
                <div>{shipping.name}</div>
                <div>
                  {shipping.address_line_1}
                  {shipping.address_line_2 ? `, ${shipping.address_line_2}` : ""}
                </div>
                <div>
                  {shipping.city} {shipping.state} {shipping.postal_code}
                </div>
                <div>{shipping.country}</div>
                {shipping.phone && <div className="mt-1">Phone: {shipping.phone}</div>}
                {shipping.email && <div>Email: {shipping.email}</div>}
              </div>
            ) : (
              <div className="font-medium text-gray-500">No shipping details available.</div>
            )}
          </div>
          <div className="w-full flex justify-center">
            <button
              type="button"
              onClick={() => window.print()}
              className="flex gap-3 rounded-full items-center justify-center bg-[#095228] hover:bg-green-800 text-white px-4 py-2 mb-6"
            >
              <FaFileDownload className="text-xl" />
              Print / Save as PDF
            </button>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-3 text-green-700">
              Items Ordered
            </h3>
           <div className=" rounded-lg  space-y-4">
              {orders.flatMap(order => order.order_items || []).map((item) => {
                const src = item.image || images[item.product_id] || "/image/shoeimg.png";
                return (
                <div key={item.id} className="border p-2 space-y-1 rounded-md">
                  <div className="flex items-center">
                    <div className=" ">
                      <img
                        src={src}
                        alt={item.product_name || "Product"}
                        className="h-[80px] w-[80px] rounded-lg mr-4 object-contain"
                      />
                    </div>

                    <div>
                      <div className="font-semibold">
                        {item.product_name || `Product ${item.product_id}`}
                      </div>
                      <div className="text-xs text-gray-500">Qty: {item.quantity}</div>
                      <div className="text-xs text-gray-500">Price: {currencySymbol}{Number(item.unit_price || item.total_price || 0).toFixed(2)}</div>
                    </div>
                  </div>
                </div>
                );
              })}
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-3 mt-6">
            <button
              type="button"
              onClick={() => navigate("/myorder")}
              className="rounded-full bg-[#095228] hover:bg-green-800 text-white px-4 py-2"
            >
              Track Your Order
            </button>
            <button
              type="button"
              onClick={() => navigate("/marketplace")}
              className="rounded-full border border-[#095228] text-[#095228] hover:bg-green-50 px-4 py-2"
            >
              Continue Shopping
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
// ...existing code...